import {EtsyListingStateEnum} from '@coolcolduk/etsy';
import {z} from 'zod';

const listingStateSchema = z.nativeEnum(EtsyListingStateEnum);

/** Stored document shape in Firestore (user/{uid}/etsyBulkUpdateGoogleSheetLink/{id}) */
export const etsyBulkUpdateGoogleSheetLinkFirebaseSchema = z.object({
  name: z.string().optional(),
  etsyAccountId: z.string(),
  spreadsheetId: z.string(),
  listingState: listingStateSchema,
  gdriveTokenId: z.string(),
  creationTimestamp: z.number().optional(),
});

export type EtsyBulkUpdateGoogleSheetLinkFirebase = z.infer<typeof etsyBulkUpdateGoogleSheetLinkFirebaseSchema>;

/** Document with id (for reading from Firestore) */
export interface EtsyBulkUpdateGoogleSheetLink extends EtsyBulkUpdateGoogleSheetLinkFirebase {
  id: string;
}

/** Input shape for create (spreadsheet as URL or id) */
export const etsyBulkUpdateGoogleSheetLinkInputSchema = z.object({
  name: z.string().optional(),
  etsyAccountId: z.string(),
  spreadsheetUrlOrId: z.string(),
  listingState: listingStateSchema,
  gdriveTokenId: z.string(),
});

export type EtsyBulkUpdateGoogleSheetLinkInput = z.infer<typeof etsyBulkUpdateGoogleSheetLinkInputSchema>;
